<app-prescription-table [prescription]="prescription"></app-prescription-table>